// extracted by mini-css-extract-plugin
export default {"welcomePageContainer":"Welcome_welcomePageContainer__Fa9UH","welcome":"Welcome_welcome__gCs03"};